import React, { useState, useEffect } from "react"
import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerJumpNavClick = props => {

  const [jumpNavExpanded, setJumpNavExpanded] = useState(false);

  const datalayerJumpNavClickHandler = event => {
    let validClasses = [
      "ter-jump-nav__nav-item",
      "ter-jump-nav__nav-link",
    ]

    if (jumpNavExpanded && containsValidTargetClass(validClasses, event?.target?.classList)) {
      window.dataLayer.push({
        event: "jumpnav_click",
        jumpnav_layout: document?.querySelectorAll(".ter-jump-nav--horizontal")?.length ? "horizontal" : "vertical",
        clickLabel: event?.target?.innerText
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query =
      document?.querySelectorAll(
        ".ter-jump-nav"
      ).length > 0
  }
  
  const isJumpNavOpenHandler = (event) => {
    if(document?.querySelector(".ter-jump-nav")?.classList?.contains("ter-jump-nav--expanded") ||
      document?.querySelector(".ter-jump-nav")?.classList?.contains("ter-jump-nav--horizontal")){
      setJumpNavExpanded(true);
    } else {
      setJumpNavExpanded(false);
    }
  }

  useEffect(() => {
    if (
      query &&
      typeof window !== "undefined" &&
      typeof document !== "undefined"
    ) {
      const gatsbyApp = document?.getElementById("___gatsby")
      gatsbyApp.addEventListener("click", datalayerJumpNavClickHandler)
      document?.querySelector(".ter-jump-nav")?.addEventListener("click", isJumpNavOpenHandler)
      return () => {
        gatsbyApp.removeEventListener("click", datalayerJumpNavClickHandler)
        document?.querySelector(".ter-jump-nav")?.removeEventListener("click", isJumpNavOpenHandler)
      }
    }
  }, [datalayerJumpNavClickHandler, query])
}

export default DatalayerJumpNavClick
